import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a low media sideboard spanning 2x1 tiles (~1.8 x 0.4 x 0.5):
// walnut body, two matte-black door fronts with steel pulls, slim legs.
const WALNUT = "#7a5a3a";
const BLACK = "#2e2e30";
const STEEL = "#aab2b8";

export const tvStand = defineModel({
  id: "tv-stand",
  batchId: "modern",
  name: "TV stand",
  tags: ["modern", "interior", "furniture", "storage", "living-room", "media"],
  summary: "A low walnut media sideboard with matte-black doors.",
  tiles: { w: 2, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // walnut body (top surface at 0.5)
      { geometry: new THREE.BoxGeometry(1.8, 0.38, 0.4), color: WALNUT, position: [0, 0.31, 0] },
      // matte-black door fronts
      { geometry: new THREE.BoxGeometry(0.84, 0.3, 0.03), color: BLACK, position: [-0.45, 0.31, 0.2] },
      { geometry: new THREE.BoxGeometry(0.84, 0.3, 0.03), color: BLACK, position: [0.45, 0.31, 0.2] },
      // steel pulls at the inner door edges
      { geometry: new THREE.BoxGeometry(0.025, 0.12, 0.02), color: STEEL, position: [-0.07, 0.31, 0.225] },
      { geometry: new THREE.BoxGeometry(0.025, 0.12, 0.02), color: STEEL, position: [0.07, 0.31, 0.225] },
      // slim legs
      { geometry: new THREE.BoxGeometry(0.05, 0.12, 0.05), color: BLACK, position: [-0.84, 0.06, 0.15] },
      { geometry: new THREE.BoxGeometry(0.05, 0.12, 0.05), color: BLACK, position: [0.84, 0.06, 0.15] },
      { geometry: new THREE.BoxGeometry(0.05, 0.12, 0.05), color: BLACK, position: [-0.84, 0.06, -0.15] },
      { geometry: new THREE.BoxGeometry(0.05, 0.12, 0.05), color: BLACK, position: [0.84, 0.06, -0.15] },
    ];
  },
  animations: [],
});
